shvenergy.imagewithcaptionandenlargement = (function ($) {
	"use strict";

	let enlargeImage = $(".enlarge-button");
	let cdnvalue = $("#cdnInput").data("value");

	$(document).on("click", ".imagewithcaption__backdrop .close", function (e) {
		hideEnlargeImage();
	});

	enlargeImage.on("mouseenter", function () {
		$(this).addClass("mouseover");
	}).on("mouseleave", function () {
		$(this).removeClass("mouseover");
	});
	
	function enlargeImageSize(content, options = {}) {
		const imageWithCaptionBackdrop = `<div class="imagewithcaption__backdrop" role="dialog">
			<div class="imagewithcaption__backdrop__main">
				<button class="close">
					<span class="inner">
						<span id="label">${options.closeText}</span>
						<svg focusable="false" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#X_16x16"></use></svg>
					</span>
				</button>
				<div class="imagewithcaption-content"></div>
			</div>
		</div>`;

		var t = $(imageWithCaptionBackdrop).clone();
		t.find(".imagewithcaption-content").html(content);

		$("body").append(t);
		$("html").addClass("imagewithcaption-open");
		$(".imagewithcaption__backdrop__main").addClass(options.extraClass);
	}

	function hideEnlargeImage() {
		$(".imagewithcaption__backdrop").remove();
		$("html").removeClass("imagewithcaption-open");
	}

	return {
		enlargeImageSize: enlargeImageSize
	};

})(jQuery);